__turbopack_context__.v({
  "deleteButton": "_5Clqha_deleteButton",
  "deleteText": "_5Clqha_deleteText",
  "spinner": "_5Clqha_spinner",
});
